export const passwords = state => state.passwords
export const password = state => state.password